<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      :class="{
        opened: opened.indexOf('addToGroups') >= 0,
        'last-active': opened.indexOf('addToGroups') === opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleGroupAddConfirmation">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="addToGroups">
          <div class="atom-icon">
            <img alt="" src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("priraditKeSkupine") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="devices">
          {{ $t("priradit") }} {{ devices.length }} {{ $t("zarizeniPocet") }}
          {{ $t("keSkupine") }}
        </h2>
      </div>
      <div class="side-box__content">
        <div class="d-flex side-box__row align-items-start">
          <span class="side-box__content__label mt-sm-5">{{ $t("routovaciSkupina") }}</span>
          <div class="w-100 side-box__content__input ml-3">
            <FormSelect
              :custom-action-text="$t('CREATE_NEW_DATA_FLOW')"
              :has-error="false"
              :items="loadedGroups"
              :placeholder="$t('DEVICE_DATA_FLOW_SELECT_PLACEHOLDER')"
              :value="selectedGroup"
              class="mb-4"
              item-subtext="technology"
              item-text="deviceGroupName"
              item-value="deviceGroupId"
              label=""
              @change="handleGroupChanged"
              @custom-action-clicked="$router.push({ name: 'dataFlowNew', params: $router.params })"
            />
          </div>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedGroupAddConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleGroupAddConfirmation"
      @no="closeBox('addToGroups')"
      @yes="addToGroups()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import FormSelect from "@/components/forms/FormSelect.vue"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    FormSelect,
    SaveConfirmationModal,
    ErrorModal
  },
  props: {
    tags: Array,
    devices: Array,
    opened: Array,
    technology: {
      type: String,
      default: "lora"
    }
  },
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      changed: false,
      loadedGroups: [],
      selectedGroup: {},
      groupsOpened: false,
      selectedParameters: [],
      openedGroupAddConfirmation: false,
      errors: {
        device: "",
        group: ""
      },
      selectGroupVisible: false,
      errorsToTranslate: [],
      openedError: false
    }
  },
  computed: {
    project() {
      return this.projectStore.selectedProject
    }
  },
  watch: {
    opened() {
      if (this.opened.indexOf("addToGroups") >= 0) {
        this.loadGroups()
      }
    }
  },
  methods: {
    async addToGroups() {
      this.errorsToTranslate = []

      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))

      for (let device of this.devices) {
        for (let group of device.deviceGroups) {
          await axios.delete(
            // un-assign old group(s) first
            `${process.env.VUE_APP_API}/device-groups/${group.deviceGroupId}/devices/${this.technology}/${device.deviceId}/assign`
          )
        }

        await axios.post(
          `${process.env.VUE_APP_API}/device-groups/${this.selectedGroup.deviceGroupId}/devices/${this.technology}/${device.deviceId}/assign`
        )

        device.deviceGroups = [this.selectedGroup]
      }

      await this.changeDevicesTransformation()

      this.$store.commit("modals/setWaitingLoader", "")
      this.$emit("reloadItems")
      this.closeBox("addToGroups")
      this.emptyValues()
    },
    async changeDevicesTransformation() {
      const tfIdStr = this.selectedGroup.tags.find((t) => t.startsWith("hidden_tf"))?.substring(10)
      if (!tfIdStr) {
        return
      }

      const tfId = parseInt(tfIdStr)

      for (let device of this.devices) {
        device.transformationId = tfId
        const isLoraDevice = !!device.parameters.devicetype // FIXME poor assessment but devices get be mixed (LORA/MQTT)
        await axios.put(
          `${process.env.VUE_APP_API}${isLoraDevice ? `/${this.technology}/devices/` : "/mqtt/gateways/"}${device.deviceId}`, device
        )
      }
    },
    closeBox(box) {
      if (!box) {
        this.emptyValues()
        this.$emit("closeBox")
      } else {
        this.$emit("closeBox", box)
      }
    },
    emptyValues() {
      this.selectedGroup = {}
      this.groupsOpened = false
    },
    handleGroupChanged(group) {
      this.changed = true
      this.selectedGroup = group
    },
    async loadGroups() {
      const response = await axios.get(
        `${process.env.VUE_APP_API}/device-groups?projectId[eq]=${this.project.projectId}&limit=1000&sort=%2BdeviceGroupName`
      )
      this.loadedGroups = response.data.data
    },
    openBox(box) {
      this.$emit("openBox", box)
    },
    toggleGroupAddConfirmation() {
      if (this.changed) {
        this.openedGroupAddConfirmation = !this.openedGroupAddConfirmation
      } else {
        this.openedGroupAddConfirmation = false
        this.$emit("closeBox", "addToGroups")
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
